export default {
  settingDialog: false
};
